import React from "react"
import styles from "./PlanToggleButton.module.scss"
import svg from "../../../utils/svg"
import { usePurchase } from "../../../context/purchaseContext"
import useStrings from "../../../localization/useStrings"

export const PlanToggleButton = () => {
  const { state: purchaseState, actions: purchaseActions } = usePurchase()
  const strings = useStrings()

  const isUltimate = purchaseState.ultimateSelected

  const handleToggle = () => {
    purchaseActions.setUltimateSelected(!isUltimate)
  }

  return (
    <button
      className={`${styles.toggleButton} ${isUltimate ? styles.switchingToPremium : styles.switchingToUltimate}`}
      onClick={handleToggle}
    >
      {isUltimate ? (
        <>
          <svg.PremiumIcon className={styles.toggleIcon} />
          <span className={styles.toggleText}>
            {strings.bubbleExpiration.switchToPremium.toUpperCase()}
          </span>
        </>
      ) : (
        <>
          <svg.UltimateIcon className={styles.toggleIcon} />
          <span className={styles.toggleText}>
            {strings.bubbleExpiration.switchToUltimate.toUpperCase()}
          </span>
        </>
      )}
    </button>
  )
}
